<template>
    <div>
        <hs-breadcrumb :breadcrumb="breadcrumb"></hs-breadcrumb>
        <Card :bordered="false" :style="{marginBottom:'10px'}">
<!--          <div class="hs-screen-row" v-if="!admin.tenantId">-->
<!--            <Select v-model="params.tenantId" placeholder="区域商户" clearable style="width:200px">-->
<!--              <Option v-for="(item, index) in tenantList" :value="item.tenantId" :key="index">{{ item.companyName }}</Option>-->
<!--            </Select>-->
<!--          </div>-->
          <div class="hs-screen-row">
                <Input v-model="params.nickName" placeholder="下单用户" clearable style="width: 200px"/>
            </div>
          <div class="hs-screen-row">
            <Input v-model="params.mobile" placeholder="下单手机号" clearable style="width: 200px"/>
          </div>
          <div class="hs-screen-row">
            <Input v-model="params.mailNo" placeholder="快递面单号" clearable style="width: 200px"/>
          </div>
            <div class="hs-screen-row">
                <Select v-model="params.orderState" placeholder="订单状态" clearable style="width:200px">
                    <Option value="">全部</Option>
                    <Option value="1">等待确认</Option>
                    <Option value="2">等待回收</Option>
                    <Option value="3">运输中</Option>
                    <Option value="4">待验收</Option>
                    <Option value="5">已完成</Option>
                    <Option value="6">已取消</Option>
                    <Option value="7">揽件失败</Option>
                    <Option value="8">快递方取消</Option>
                </Select>
            </div>
            <div class="hs-screen-row">
                <DatePicker @on-change="changeDate" v-model="dateInit" type="daterange" :editable="false"
                            separator=" ~ " split-panels transfer
                            placeholder="创建时间" style="width: 200px"></DatePicker>
            </div>
          <div class="hs-screen-row">
            <DatePicker @on-change="changeSuccessDate" v-model="successDateInit" type="daterange" :editable="false"
                        separator=" ~ " split-panels transfer
                        placeholder="完成时间" style="width: 200px"></DatePicker>
          </div>
<!--          <div class="hs-screen-row">-->
<!--            <DatePicker @on-change="changeCancelDate" v-model="cancelDateInit" type="daterange" :editable="false"-->
<!--                        separator=" ~ " split-panels transfer-->
<!--                        placeholder="申请取消时间" style="width: 200px"></DatePicker>-->
<!--          </div>-->
            <div class="hs-screen-row">
                <Button type="primary" @click="findList">查询</Button>
            </div>
            <div class="hs-screen-row">
                <Button @click="resetScreen">重置</Button>
            </div>
        </Card>

        <Card :bordered="false" :style="{marginBottom:'10px'}">
            <!--标题-->
            <div slot="title">
                <div class="hs-screen-box">
                    <div>订单列表</div>
                    <div>
                        <ButtonGroup>
                            <Button @click="findList">
                                <Icon type="md-refresh" size="15"/>
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>
            </div>

            <div style="margin-bottom: 10px">
                <Button type="dashed" @click="batchOpe" v-if="admin.tenantId">导出订单</Button>
<!--              <Button type="success" size="small" style="margin-left: 10px" @click="showOrderMap()">订单地图</Button>-->
            </div>

            <!--表格数据-->
            <Table :columns="columns" :data="data" size="small" :stripe="true" :loading="isTableLoading"
                   @on-select="selectTable" @on-select-cancel="selectCancelTable" @on-select-all="selectAllTable"
                   @on-select-all-cancel="selectAllCancelTable">

                <template slot-scope="{ row, index }" slot="orderState">
                    <span v-if="row.orderState == 1"><Tag color="primary">等待确认</Tag></span>
                    <span v-if="row.orderState == 2"><Tag color="warning">等待回收</Tag></span>
                    <span v-if="row.orderState == 3"><Tag color="warning">运输中</Tag></span>
                    <span v-if="row.orderState == 4"><Tag color="primary">待验收</Tag></span>
                    <span v-if="row.orderState == 5"><Tag color="success">已完成</Tag></span>
                    <span v-if="row.orderState == 6"><Tag color="default">已取消</Tag></span>
                    <span v-if="row.orderState == 7"><Tag color="error">揽件失败</Tag></span>
                    <span v-if="row.orderState == 8"><Tag color="error">快递方取消</Tag></span>
                </template>

                <template slot-scope="{ row, index }" slot="expressType">
                    <span v-if="row.expressType == 1"><Tag color="success">德邦快递</Tag></span>
                    <span v-if="row.expressType == 2"><Tag color="warning">京东快递</Tag></span>
                    <span v-if="row.expressType == 3"><Tag color="primary">顺丰快递</Tag></span>
                </template>


                <template slot-scope="{ row, index }" slot="isPass">
                    <span v-if="row.isPass == 1"><Tag color="success">合格</Tag></span>
                    <span v-if="row.isPass == 0"><Tag color="error">不合格</Tag></span>
                </template>
                <template slot-scope="{ row, index }" slot="isJunk">
                  <span v-if="row.isJunk == 0"><Tag color="success">否</Tag></span>
                  <span v-if="row.isJunk == 1"><Tag color="error">是</Tag></span>
                </template>
                <template slot-scope="{ row, index }" slot="totalAmount">
                    <span v-if="row.totalAmount">{{row.totalAmount}}</span>
                    <span v-else>-</span>
                </template>

                <template slot-scope="{ row, index }" slot="realName">
                  <span v-if="row.realName">{{row.realName}}</span>
                  <span v-else>{{row.nickName}}</span>
                </template>

                <template slot-scope="{ row, index }" slot="integral">
                    <span v-if="row.integral">{{row.integral}}</span>
                    <span v-else>-</span>
                </template>

                <template slot-scope="{ row }" slot="action">
                    <Button type="success" size="small" style="margin-right: 5px" @click="showOrderOpe(row)">查看
                    </Button>
                  <Button type="primary" size="small" style="margin-right: 5px" @click="showOrderDispatch(1, row)" v-if="row.orderState === 1">派单
                  </Button>
                  <Button type="primary" size="small" style="margin-right: 5px" @click="showOrderPass(row)" v-if="row.orderState === 4">订单质检
                  </Button>
                    <Dropdown transfer trigger="click">
                        <Button size="small">
                            <Icon type="ios-more" size="22"/>
                        </Button>
                        <DropdownMenu slot="list">
                            <DropdownItem @click.native="isOrderCancel(row)" v-if="row.orderState == 1 || row.orderState === 2">取消订单
                            </DropdownItem>
                            <DropdownItem @click.native="isDeleteOrderMall(row)" v-if="row.orderState > 2">删除
                            </DropdownItem>
                            <DropdownItem @click.native="isDisableUser(row)">禁用用户
                            </DropdownItem>
                            <DropdownItem @click.native="isJunkOrder(row)" v-if="row.orderState === 5">标记垃圾订单
                            </DropdownItem>
                            <DropdownItem @click.native="showOrderHistory(row)">历史订单
                            </DropdownItem>
                            <DropdownItem @click.native="showOrderDispatch(2, row)" v-if="row.orderState === 2">修改仓库
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </template>
            </Table>
            <!--分页-->
            <div class="hs-page">
                <Page :total="total" show-sizer show-total transfer @on-change="changePage"
                      @on-page-size-change="changePageSize"/>
            </div>
        </Card>

        <!--显示模态框-->
        <order-ope ref="orderOpe"></order-ope>
        <order-map ref="orderMap"></order-map>
        <order-update ref="orderUpdate"></order-update>
        <!--显示模态框-->
        <order-dispatch ref="orderDispatch" @changeDate="findList"></order-dispatch>
        <order-pass ref="orderPass" @changeDate="findList"></order-pass>
        <order-history ref="orderHistory"></order-history>
        <!--物流跟踪-->
<!--        <order-logistics-tracking ref="orderLogisticsTracking"></order-logistics-tracking>-->
        <!--订单评价信息-->
        <order-evaluate ref="orderEvaluate" @changeDate="findList"></order-evaluate>
    </div>
</template>

<script>
    import hsBreadcrumb from '@/components/hs-breadcrumb';
    import orderOpe from './components/order-ope';
    import orderDispatch from './components/order-dispatch';
    import orderPass from './components/order-pass';
    import orderEvaluate from './components/order-evaluate';
    import orderMap from './components/order-map';
    import orderUpdate from './components/order-update';
    import orderHistory from './components/order-history';
    export default {
        name: "admin",
        data() {
            return {
                admin: JSON.parse(sessionStorage.getItem('J-ADMIN')),
                total: 0,
                importSuccess:0,
                importFailed:0,
                dateInit: '',
                successDateInit: '',
                cancelDateInit: '',
                isTableLoading: false,
                // 选中数据
                selectData: [],
                action: this.$apiURL + '/orderMall/importOrderExcel',
                headers: {
                    token: JSON.parse(sessionStorage.getItem('J-TOKEN')).token
                },
                // 参数
                params: {
                    page: 1,
                    rows: 10,
                    orderTitle: '',
                    orderState: '',
                    orderType: '',
                    nickName: '',
                    startTime: '',
                    endTime: '',
                    recoveryUserId: '',
                    payType: '',
                    startUpdateTime: '',
                    endUpdateTime: '',
                    // tenantId: '',
                    userId: '',
                    cancelCauses: '',
                    startCancelTime: '',
                    endCancelTime: '',
                    mobile: ''
                },
                // 表格列
                columns: [
                    /*{
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },*/
                    {
                        type: 'index',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: 'ID',
                        minWidth: 130,
                        key: 'recoveryOrderId'
                    },
                    {
                        title: '订单编号',
                        minWidth: 190,
                        key: 'orderCode'
                    },
                    {
                        title: '订单标题',
                        minWidth: 90,
                        key: 'orderTitle',
                        ellipsis: true
                    },
                    {
                        title: '订单状态',
                        slot: 'orderState',
                        align: 'center',
                        width: 120
                    },
                    {
                        title: '快递类型',
                        slot: 'expressType',
                        align: 'center',
                        width: 120
                    },
                    {
                      title: '快递面单号',
                      minWidth: 160,
                      key: 'mailNo',
                      ellipsis: true
                    },
                    {
                        title: '预约时间',
                        key: 'recoveryTime',
                        align: 'center',
                        width: 170
                    },
                    {
                      title: '预估重量',
                      minWidth: 90,
                      key: 'estimateWeight'
                    },
                  {
                    title: '质检结果',
                    slot: 'isPass',
                    align: 'center',
                    width: 120
                  },
                  {
                    title: '垃圾订单',
                    slot: 'isJunk',
                    align: 'center',
                    width: 120
                  },
                    {
                        title: '回收金额（元）',
                        minWidth: 120,
                        slot: 'totalAmount'
                    },
                    {
                        title: '赠送积分',
                        minWidth: 120,
                        slot: 'integral'
                    },
                    {
                        title: '用户名',
                        minWidth: 180,
                        slot: 'realName'
                    },
                    {
                        title: '创建时间',
                        key: 'createTime',
                        width: 150
                    },
                    {
                      title: '完成时间',
                      key: 'successTime',
                      width: 150
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        width: 225,
                        align: 'center',
                        fixed:'right'
                    }
                ],
                // 表格数据
                data: [],
                failOrderColumns:[
                    {
                        title: '订单编号',
                        minWidth: 190,
                        key: 'orderCode'
                    },
                    {
                        title: '订单标题',
                        minWidth: 280,
                        key: 'orderTitle',
                        ellipsis: true
                    }
                ],
                failOrderData:[],
                // 面包屑
                breadcrumb: [
                    {name: '首页', url: '', icon: 'ios-home-outline', size: 18},
                    {name: '订单管理', url: '', icon: '', size: 0},
                    {name: '订单列表', url: '', icon: '', size: 0}
                ],
                recoveryUserList: [],
                tenantList: []
            }
        },
        created() {
            this.params.recoveryUserId = this.$route.query.recoveryUserId
            this.params.startUpdateTime = this.$route.query.startTime
            this.params.endUpdateTime = this.$route.query.endTime
            this.params.orderState = this.$route.query.orderState
            this.params.userId = this.$route.query.userId // 意见反馈页
            // 订单-列表查询
            this.findList();
            this.findRecoveryUserList()

        },
        methods: {
            // 租户查询
            // findTenantAll() {
            //   this.axios.post('/tenant/findAll').then(res => {
            //     if (res.status == 200) {
            //       this.tenantList = res.data;
            //       if (!this.admin.tenantId) {
            //         this.params.tenantId = this.tenantList[0].tenantId
            //       }
            //       this.findList();
            //     }
            //     if (res.status == 201) {
            //       this.$Message.error(res.msg);
            //     }
            //     if (res.status == 500) {
            //       this.$Notice.error({
            //         title: '服务器内部错误',
            //         desc: '查询加盟商列表接口报错',
            //         duration: 0
            //       });
            //     }
            //   })
            // },
            // 订单-列表查询
            findList() {
                this.isTableLoading = true;
                this.axios.post('/recoveryOrder/findList', this.params).then(res => {
                    this.isTableLoading = false;
                    if (res.status == 200) {
                        this.total = res.data.total;
                        this.data = res.data.rows;
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '查询订单列表接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 是否取消订单
            isOrderCancel(row) {
                this.$Modal.confirm({
                    title: `是否取消当前订单？`,
                    onOk: () => {
                        // this.$Message.info('您点击了确定.');
                        this.orderCancel(row);
                    },
                    onCancel: () => {
                        this.$Message.info('您点击了取消.');
                    }
                });
            },
            // 是否删除订单
            isDeleteOrderMall(row) {
                // console.log(row)
                this.$Modal.confirm({
                    title: `是否删除当前订单？`,
                    onOk: () => {
                        // this.$Message.info('您点击了确定.');
                        this.deleteOrderMall(row);
                    },
                    onCancel: () => {
                        this.$Message.info('您点击了取消.');
                    }
                });
            },
            // 是否处理异常订单
          isJunkOrder(row) {
                // console.log(row)
                this.$Modal.confirm({
                    title: `是否标记为垃圾订单？`,
                    onOk: () => {
                        // this.$Message.info('您点击了确定.');
                        this.junkOrder(row);
                    },
                    onCancel: () => {
                        this.$Message.info('您点击了取消.');
                    }
                });
            },
            // 取消订单
            orderCancel(row) {
                this.$Spin.show();
                this.axios.post('/recoveryOrder/orderCancel', {
                    recoveryOrderId: row.recoveryOrderId
                }).then(res => {
                    console.log(res);
                    setTimeout(() => {
                        this.$Spin.hide();
                    }, 300);
                    if (res.status == 200) {
                        this.$Message.success('操作成功.');
                        this.findList();
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '取消订单接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 删除订单
            deleteOrderMall(row) {
                this.$Spin.show();
                this.axios.post('/recoveryOrder/deleteOrder', {
                    recoveryOrderId: row.recoveryOrderId
                }).then(res => {
                    console.log(res);
                    setTimeout(() => {
                        this.$Spin.hide();
                    }, 300);
                    if (res.status == 200) {
                        this.$Message.success('操作成功.');
                        this.findList();
                    }
                    if (res.status == 201) {
                        // this.$Message.error(res.msg);
                        this.$Notice.error({
                            title: '删除订单失败',
                            desc: res.msg
                        });
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '删除订单接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 处理异常
          junkOrder(row) {
                this.$Spin.show();
                this.axios.post('/recoveryOrder/junkOrder', {
                    recoveryOrderId: row.recoveryOrderId
                }).then(res => {
                    console.log(res);
                    setTimeout(() => {
                        this.$Spin.hide();
                    }, 300);
                    if (res.status == 200) {
                        this.$Message.success('操作成功.');
                        this.findList();
                    }
                    if (res.status == 201) {
                        // this.$Message.error(res.msg);
                        this.$Notice.error({
                            title: '标记垃圾订单失败',
                            desc: res.msg
                        });
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '标记垃圾订单接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 修改仓库
            updateOrder(row) {
              this.$refs.orderDispatch.show(row);
            },
            // 导出订单Excel
            exportExcel() {
                this.$Spin.show();
                this.axios.post('/recoveryOrder/exportOrderExcel', this.params, {
                    responseType: 'arraybuffer'
                }).then(res => {
                    console.log(res);
                    setTimeout(() => {
                        this.$Spin.hide();
                    }, 300);
                    // console.log(res);
                    let blob = new Blob([res], {type: 'Files'});
                    let csvUrl = URL.createObjectURL(blob);
                    let link = document.createElement('a');
                    link.href = csvUrl;
                    // 下载xlsx文件
                    link.download = "回收订单列表.xls";
                    link.click();
                    if (res.status == 201) {
                        // this.$Message.error(res.msg);
                        this.$Notice.error({
                            title: '删除订单失败',
                            desc: res.msg
                        });
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '删除订单接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 显示操作模态框
            showOrderOpe(row) {
                this.$refs.orderOpe.show(row);
            },
            // 订单地图
            showOrderMap() {
              this.$refs.orderMap.show();
            },
            // 显示派单模态框 type 1指派仓库 2修改仓库
            showOrderDispatch(type, row) {
              this.$refs.orderDispatch.show(type, row);
            },
            // 显示质检模态框
            showOrderPass(row) {
              this.$refs.orderPass.show(row);
            },
            // 显示订单评价
            // showOrderEvaluate(row) {
            //     this.$refs.orderEvaluate.show(row);
            // },
            // 发货，修改物流信息
            // showOrderLogisticsNumber(row, type) {
            //     this.$refs.orderLogisticsNumber.show(row, type);
            // },
            // 显示自定义退款页面
            // showOrderCustomRefund(row, type) {
            //     this.$refs.orderCustomRefund.show(row, type);
            // },
            // 修改订单
            showOrderUpdate(row) {
              this.$refs.orderUpdate.show(row);
            },
            showOrderHistory(row) {
              this.$refs.orderHistory.show(row);
            },
            // 日期条件赋值
            changeDate(e) {
                this.params.startTime = e[0];
                this.params.endTime = e[1];
            },
            changeSuccessDate(e) {
              this.params.startUpdateTime = e[0];
              this.params.endUpdateTime = e[1];
            },
            changeCancelDate(e) {
              this.params.startCancelTime = e[0];
              this.params.endCancelTime = e[1];
            },
            // 重置筛选条件
            resetScreen() {
                this.params.orderState = '';
                this.params.orderType = '';
                this.params.nickName = '';
                this.params.username = '';
                this.params.startTime = '';
                this.params.endTime = '';
                this.params.recoveryUserId = '';
                this.params.startUpdateTime = '';
                this.params.endUpdateTime = '';
                this.params.userId = '';
                this.dateInit = '';
                this.successDateInit = '';
                this.cancelDateInit = '';
                this.params.mailNo = '';
                this.params.startCancelTime = '';
                this.params.endCancelTime = '';
                this.params.mobile = ''
            },
            // 改变页数
            changePage(e) {
                this.params.page = e;
                this.findList();
            },
            // 改变页容量
            changePageSize(e) {
                this.params.rows = e;
                this.findList();
            },
            // 在多选模式下有效，选中某一项时触发
            selectTable(selection, row) {
                this.selectData = selection;
            },
            // 在多选模式下有效，取消选中某一项时触发
            selectCancelTable(selection, row) {
                this.selectData = selection;
            },
            // 在多选模式下有效，点击全选时触发
            selectAllTable(selection) {
                this.selectData = selection;
            },
            // 在多选模式下有效，点击取消全选时触发
            selectAllCancelTable(selection) {
                this.selectData = selection;
            },
            batchOpe() {
                let arr = [];
                if (this.selectData.length) {
                    this.selectData.forEach(v => {
                        arr.push(v.recoveryOrderId)
                    })
                }
                this.params.recoveryOrderIds = arr.join(',');
                if (this.params.recoveryOrderIds) {
                    this.$Modal.confirm({
                        title: `确定导出选中的订单？`,
                        onOk: () => {
                            // this.$Message.info('您点击了确定.');
                            this.exportExcel();
                        },
                        onCancel: () => {
                            this.$Message.info('您点击了取消.');
                        }
                    });
                } else {
                    this.$Modal.confirm({
                        title: `确定导出订单？`,
                        onOk: () => {
                            // this.$Message.info('您点击了确定.');
                            this.exportExcel();
                        },
                        onCancel: () => {
                            this.$Message.info('您点击了取消.');
                        }
                    });
                }
            },
            // 上传之前
            beforeUpload(){
                this.$Spin.show();
            },
            // 上传失败
            onError(){
                this.$Spin.hide();
                this.$Message.error('上传出错！')
            },
            // 导入excel成功之后返回的数据
            uploadSuccess(response, file, fileList) {
                console.log(response)
                setTimeout(() => {
                    this.$Spin.hide();
                }, 300);
                if (response.status == 200) {
                    this.$Message.success('操作成功');
                    this.importSuccess = response.data.successNum;
                    this.importFailed = response.data.failureNum;
                    this.failOrderData = response.data.failOrder;
                }
                if (response.status == 201) {
                    this.$Message.error(response.msg);
                }
                if (response.status == 500) {
                    this.$Notice.error({
                        title: '服务器内部错误',
                        desc: '上传商品组图接口报错',
                        duration: 0
                    });
                }
            },
          // 回收员-列表查询
          findRecoveryUserList() {
            let params = {
                page: 1,
                rows: 20,
                isDisable: 0,
                tenantId: this.params.tenantId
            }
            this.axios.post('/recoveryUser/findList', params).then(res => {
              if (res.status == 200) {
                if (res.data.rows) {
                  this.recoveryUserList = []
                  res.data.rows.forEach(v => {
                    let object = {
                      value: v.recoveryUserId,
                      label: v.realName
                    }
                    this.recoveryUserList.push(object)
                  })
                }
              }
              if (res.status == 500) {
                this.$Notice.error({
                  title: '服务器内部错误',
                  desc: '查询回收员列表接口报错',
                  duration: 0
                });
              }
            })
          },
          // 是否禁用用户
          isDisableUser(row) {
            this.$Modal.confirm({
              title: `是否禁用用户${row.nickName}？`,
              onOk: () => {
                this.disableUser(row);
              },
              onCancel: () => {
                this.$Message.info('您点击了取消.');
              }
            });
          },
          // 禁用或开启用户
          disableUser(row) {
            this.$Spin.show();
            this.axios.post('/user/disableUser', {
              userId: row.userId,
              isDisable: 1
            }).then(res => {
              console.log(res);
              setTimeout(() => {
                this.$Spin.hide();
              }, 300);
              if (res.status == 200) {
                this.$Message.success('操作成功.');
                this.findList();
              }
              if (res.status == 500) {
                this.$Notice.error({
                  title: '服务器内部错误',
                  desc: '禁用用户接口报错',
                  duration: 0
                });
              }
            })
          },
        },
        components: {
            hsBreadcrumb,
            orderOpe,
            orderDispatch,
            orderEvaluate,
            orderMap,
            orderUpdate,
            orderHistory,
            orderPass
        }
    }
</script>

<style scoped lang="less">
    .hs-upload-image-box {
        width: 485px;
        display: flex;
        align-items: center;
        justify-content: center;

        .hs-upload-add {
            cursor: pointer;
            width: 100%;
            height: 43px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px dashed #cccccc;
            transition: all .3s;

            &:hover {
                color: #2d8cf0;
                border: 1px dashed #2d8cf0;
            }
        }
    }
    .z-import-message{
        margin: 10px 0;
    }
</style>
